<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-btn small color="primary" to="/fabrics">Back to Fabrics</v-btn>
      </v-flex>
      <v-flex xs8 offset-xs2 v-if="fabric">
        <v-card>
          <v-card-title>
            <h4>{{ fabric.name }} - ({{ fabric.group.type }} - {{ fabric.group.name }})</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-select v-model="fabric.category" :items="fabricCategories" item-text="name" item-value="_id" label="Pricing Categories (Note: Leave this blank for curtain fabrics)"></v-select>
                <v-text-field v-model="fabric.position" label="Fabric Position (1 is highest)"></v-text-field>
                <v-text-field v-model="fabric.minWidth" label="Min Width"></v-text-field>
                <v-text-field v-model="fabric.maxWidth" label="Max Width"></v-text-field>
                <v-text-field v-model="fabric.minDrop" label="Max Drop"></v-text-field>
                <v-text-field v-model="fabric.maxDrop" label="Max Drop"></v-text-field>
                <v-text-field v-model="fabric.priceFrom" label="From Price"></v-text-field>
                <v-text-field v-model="fabric.twcName" label="TWC Name"></v-text-field>
                <v-text-field v-model="fabric.smallImage" label="Small Image"></v-text-field>
                <v-text-field v-model="fabric.largeImage" label="Large Image"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-card>
                  <v-card-title>
                    <h4>Curtain Categories</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-select v-model="fabric.categoryNonSFoldCentre" :items="fabricCategories" item-text="name" item-value="_id" label="Non-SFold Centre Opening"></v-select>
                    <v-select v-model="fabric.categoryNonSFoldOneway" :items="fabricCategories" item-text="name" item-value="_id" label="Non-Sfold One Way"></v-select>
                    <v-select v-model="fabric.categorySFoldCentre" :items="fabricCategories" item-text="name" item-value="_id" label="SFold Centre Opening"></v-select>
                    <v-select v-model="fabric.categorySFoldOneWay" :items="fabricCategories" item-text="name" item-value="_id" label="SFold One Way"></v-select>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-title>
                    <h4>Cleaning and Energy Information</h4>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text>
                    <v-text-field v-model="fabric.properties" label="Cleaning Instructions"></v-text-field>
                    <v-btn-toggle v-model="fabric.starRating">
                      <v-btn flat>
                        1<v-icon>star</v-icon>
                      </v-btn>
                      <v-btn flat>
                        2<v-icon>star</v-icon>
                      </v-btn>
                      <v-btn flat>
                        3<v-icon>star</v-icon>
                      </v-btn>
                      <v-btn flat>
                        4<v-icon>star</v-icon>
                      </v-btn>
                      <v-btn flat>
                        5<v-icon>star</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-btn large color="primary" @click="updateFabric()" :loading="loading">Update</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-snackbar dark top v-model="snackbar" :timeout="3000">
      {{ popupText }}
      <v-btn dark flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import FabricService from '@/services/FabricService.js'
import FabricCategoryService from '@/services/FabricCategoryService.js'
export default {
  data () {
    return {
      fabricID: this.$route.params.fabricID,
      fabric: null,
      fabricCategories: [],
      snackbar: false,
      popupText: null,
      loading: false
    }
  },
  mounted () {
    this.getFabric(this.fabricID)
    this.getFabricCategories()
  },
  methods: {
    async getFabric (fabricID) {
      const response = await FabricService.getFabric(fabricID)
      this.fabric = response.data.fabric
    },

    async getFabricCategories () {
      const response = await FabricCategoryService.getFabricCategories()
      this.fabricCategories = response.data.fabricCategories
    },

    async updateFabric () {
      this.loading = true
      this.fabric.minWidth = parseInt(this.fabric.minWidth)
      this.fabric.maxWidth = parseInt(this.fabric.maxWidth)
      this.fabric.minDrop = parseInt(this.fabric.minDrop)
      this.fabric.maxDrop = parseInt(this.fabric.maxDrop)
      const response = await FabricService.updateFabric(this.fabric)
      if (response.data.success) {
        this.popupText = 'Fabric updated sucessfully'
        this.snackbar = true
        this.loading = false
      } else {
        this.popupText = 'Failed to update fabric'
        this.snackbar = true
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/fabrics/EditFabric.vue